export default __webpack_public_path__ + "static/Parachute-05cbf8454998f3d8f6d510ce0c975565.png";